export default "__VITE_ASSET__2231d1e8__"